import { queryOptions, skipToken, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { getPlanPermissions } from '@/lib/api/adaptive-planner/plan-permissions';
import { adaptivePlannerQueryKeys } from '@/lib/query-keys/adaptivePlanner';

const createPlanPermissionQueryConfig = ({ planId }: { planId: number }) => ({
  queryKey: adaptivePlannerQueryKeys.plans.permission({ planId }),
  queryFn: async () => {
    const permissions = await getPlanPermissions({ planIds: [planId] });
    return permissions.find((permission) => permission.planId === planId) ?? null;
  },
  staleTime: Infinity,
});

export const usePlanPermissionOptions = ({ planId }: { planId?: number }) =>
  queryOptions({
    queryKey: adaptivePlannerQueryKeys.plans.permission({ planId }),
    queryFn: planId
      ? async () => {
          const permissions = await getPlanPermissions({ planIds: [planId] });
          return permissions.find((permission) => permission.planId === planId) ?? null;
        }
      : skipToken,
    staleTime: Infinity,
  } as const);

export const usePlanPermissionSuspenseOptions = ({ planId }: { planId: number }) =>
  queryOptions(createPlanPermissionQueryConfig({ planId }));

export const usePlanPermission = ({ planId }: { planId?: number }) =>
  useQuery(usePlanPermissionOptions({ planId }));

export const usePlanPermissionSuspenseQuery = ({ planId }: { planId: number }) =>
  useSuspenseQuery(usePlanPermissionSuspenseOptions({ planId }));
